 <!--Main COintainer Starts-->
  <div [@routerTransition]>
    <!--User Profile wizard Starts
      *ngIf="ShowpatientDeatils"
        -->
    <div class="row margin-top-16px">
      <div class=" col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form ">

        <div class=" nurse-profile-card-body  padding-bottom-0px">
          <div class="row">
            <!--<div class="col-md-2 padding-right-0px color-col-md-2 padding-top-5">-->
            <div class="position-fixed-2 height-100pe margin-left-14px">
              <div class="card height-100pe">
                <div class="card-body padding-all-0px margin-left-0px">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-12 wh-header  card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                      <div class="row">
                        <label class="font-size-14px">
                          Help Document
                        </label>

                      </div>
                      <div class="row">
                        <label class="font-size-16px color-Assign">
                          IVF
                        </label>

                      </div>
                    </div>
                  </div>
                  <!--<div class="row">
                    <a class="nav-link-hand margin-left-29px margin-top-12p" title="Partner" (click)="flip()"><i class="fas fa-angle-double-left font-size-16px nav-link-hand"></i> Back</a>
                  </div>-->
                 
                  
                  <div class="row">
                    <div class="col-md-12 padding-left-3px padding-right-5px">


                      <!--<ul id="nav-tabs-wrapper" class="nav nav-tabs nav-pills nav-stacked well width-211px display-inherit border-bottom-0px">
        <li class="nav-link4 border-top-light border-bottom-light padding-top-3px padding-bottom-3px active"><a class="link2 margin-left-17px active" href="#vtab1" data-toggle="tab">Profile<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a></li>
        <li class="nav-link4 border-bottom-light padding-top-3px padding-bottom-3px"><a class="link2 margin-left-17px" href="#vtab2" data-toggle="tab">Messages<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i></a></li>

      </ul>-->
                      <nav>
                        <div class="nav nav-tabs  width-211px display-inherit border-bottom-0px">
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Scans<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Ready For Pickup<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Pickup<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            OQA<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Insemination<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Seman Analysis<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Embryo Grading<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Embryo Transfer<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                          <a class="nav-item nav-link link2 margin-left-17px   border-top-light border-bottom-light" role="tab"
                             data-toggle="pill" href="#Ivfhelpscans">
                            Prgency Tracker<i class="fas fa-caret-right icon-caret-right float-right margin-top-3px"></i>
                          </a>
                        </div>
                      </nav>


                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!--</div>-->
            <div class=" offset-md-2 col-md-10 padding-left-0px padding-right-0px primary-background">
              <div class="tab-content">


                
                <div class="tab-pane container" id="Ivfhelpscans" role="tabpanel">

                  <div>
                    <ivfhelpscans ></ivfhelpscans>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!--User Profile wizardEnd-->
  </div>
<!--<providerdashboard *ngIf="showdashboard" hidden></providerdashboard>-->
<!--Main COintainer ends-->
<!--<div *ngIf="IsSetAccessRights">-->
<!--<div *ngIf="0 == 1">

  <section id="user-profile">
    <div class="row">
      <div class="col-12">
        <div class="card profile-with-cover">
          <div class="media profil-cover-details row">
            <div class="col-6">
              <div class="align-self-start halfway-fab pl-3 pt-2">
                <div class="text-left">
                  <h3 class="card-title pink mb-4">{{CurrentActorProfileController.DisplayName}}</h3>
                </div>
              </div>
            </div>

            <div class="col-6">

            </div>
          </div>
          <div class="profile-section">
            <div class="row">
              <div class="col-lg-6 col-md-6 ">
                <ul class="profile-menu no-list-style">
                  <li>
                    <a (click)="showPage('About')" [ngClass]="currentPage === 'About' ? 'primary font-medium-2 font-weight-600 active' : 'primary font-medium-2 font-weight-600'">Profile</a>
                  </li>
                  <li>
                    <a (click)="showPage('Friends')" [ngClass]="currentPage === 'Friends' ? 'primary font-medium-2 font-weight-600 active' : 'primary font-medium-2 font-weight-600'">Registries</a>
                  </li>

                </ul>
              </div>
              <div class="col-lg-6 col-md-6">
                <ul class="profile-menu no-list-style"></ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="about" *ngIf="currentPage === 'About'">

    <div class="row">
      <div class="col-sm-12">
        <profilesummary [ActorCode]='CurrentActorProfileController.ActorCode'
                        [CanEdit]='CanEditProfileSummary' [CanShow]='CanShowProfileSummary'
                        *ngIf="CurrentActorProfileController.ActorCode >0"></profilesummary>


      </div>

      <div class="col-sm-12">
        <personalinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                      [CanEdit]='CanEditProfileInfo' [CanShow]='CanShowProfileInfo'
                      (personalInfoChange)="onpersonalInfoChange($event)" *ngIf="CurrentActorProfileController.ActorCode >0"></personalinfo>
      </div>
      <div class="col-sm-12">

        <contactinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                     [CanEdit]='CanEditContactInfo' [CanShow]='CanShowContactInfo'
                     *ngIf="CurrentActorProfileController.ActorCode >0"></contactinfo>


      </div>
      <div class="col-sm-12">
        <employmentpreferences [ActorCode]='CurrentActorProfileController.ActorCode'
                               [CanEdit]='CanEditJobPreferences' [CanShow]='CanShowJobPreferences'
                               *ngIf="CurrentActorProfileController.ActorCode >0"></employmentpreferences>

      </div>
      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <legalinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                       [CanEdit]='CanEditLegalinfo' [CanShow]='CanShowLegalinfo'
                       *ngIf="CurrentActorProfileController.ActorCode >0"></legalinfo>
          </div>
          <div class="col-sm-6">
            <educationinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                           [CanEdit]='CanEditEducation' [CanShow]='CanShowEducation'
                           *ngIf="CurrentActorProfileController.ActorCode >0"></educationinfo>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <employeehistoryinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                 [CanEdit]='CanEditEmploymentHistory' [CanShow]='CanShowEmploymentHistory'
                                 *ngIf="CurrentActorProfileController.ActorCode >0"></employeehistoryinfo>
          </div>
          <div class="col-sm-6">
            <professionalreference [ActorCode]='CurrentActorProfileController.ActorCode'
                                   [CanEdit]='CanEditReferences' [CanShow]='CanShowReferences'
                                   *ngIf="CurrentActorProfileController.ActorCode >0"></professionalreference>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <div class="row">
          <div class="col-sm-6">
            <identitiesinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                            [CanEdit]='CanEditIdentities' [CanShow]='CanShowIdentities'
                            *ngIf="CurrentActorProfileController.ActorCode >0"></identitiesinfo>
          </div>
          <div class="col-sm-6">
            <certificationsinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                [CanEdit]='CanEditCertifications' [CanShow]='CanShowCertifications'
                                *ngIf="CurrentActorProfileController.ActorCode >0"></certificationsinfo>
          </div>
        </div>
      </div>

      <div class="col-sm-12">

        <medicalfitnessinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                            [CanEdit]='CanEditMedicalFitness' [CanShow]='CanShowMedicalFitness'
                            *ngIf="CurrentActorProfileController.ActorCode >0"></medicalfitnessinfo>


      </div>

    </div>
  </section>
  <section id="timeline" *ngIf="currentPage === 'TimeLine'">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">

        </div>
        <div class="card-body">
          <employmentpreferences [ActorCode]='CurrentActorProfileController.ActorCode' *ngIf="CurrentActorProfileController.ActorCode >0"></employmentpreferences>

        </div>
      </div>

    </div>
  </section>
  <section id="timeline" *ngIf="currentPage === 'Friends'">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">

        </div>
        <div class="card-body">
          <registryview [NurseActorCode]='CurrentActorProfileController.ActorCode'></registryview>

        </div>
      </div>

    </div>
  </section>
</div>-->

